/** Created by azhou on 2019/2/19.*/
<template>
  <div class="blank_space edieditRoom">
    <left-text-border class="mb-3"
                      leftText="房间名称"
                      placeholder="主标题"
                      required
                      v-model="RoomObj.title"/>
    <left-text-border class="mb-3"
                      leftText="副标题"
                      placeholder="例如：智能房"
                      v-model="RoomObj.assist"/>
    <div class="d-center mb-2">
      <left-text-border class="w-50 mb-2 mr-2  lisq"
                        leftText="房间总数"
                        v-model="RoomObj.num"
                        placeholder="房型数量"
                        appendText="间"
                        required/>  
      <left-text-border class="w-50 mb-2 ml-2 lisq"
                        leftText="房间面积"
                        v-model="RoomObj.area"
                        placeholder="房间面积"
                        appendText="m²"
                        required/>
    </div>
    <div class="mb-3 d-center-start" v-if="brand">
      <left-text leftText="房间类型" required/>
      <el-radio-group v-model="RoomObj.type">
        <el-radio class="mr-4" :label="item.id" v-for="item in $GVAR.brandroomStyle" :key="item.name">{{item.name}}</el-radio>
      </el-radio-group>
    </div>
    <div class="mb-3 d-center-start lh2" v-else>
      <left-text leftText="房间类型" required/>
      <el-radio-group v-model="RoomObj.type">
        <el-radio :label="item.id" v-for="item in roomStyle" :key="item.name">{{item.name}}</el-radio>
      </el-radio-group>
    </div>
    <div class="mb-3 d-center-start">
      <left-text-radio2 class="mb-2 w-100 require-middle"
        required
        leftText="床型规格"        
        v-model="RoomObj.specs"
        :options="$GVAR.specsStyle"
      />
    </div>
    <div class="mb-3 d-center-start" >
      <left-text leftText="房间窗户" required/>
      <el-radio-group v-model="RoomObj.window">
        <el-radio class="mr-4" :label="item.id" v-for="item in $GVAR.windowStyle" :key="item.name">{{item.name}}</el-radio>
      </el-radio-group>
    </div>
    <left-text-checkbox 
      class="mb-3"
      leftText="房间用品"                   
      v-model="RoomObj.feature"
      :options="$GVAR.RoomAmenities"
    />
    <left-text-checkbox 
      class="mb-3"
      leftText="房间设施"                   
      v-model="RoomObj.feature"
      :options="$GVAR.RoomFacility"
    />
    <left-text-checkbox 
      class="mb-3"
      leftText="房间设备"                   
      v-model="RoomObj.feature"
      :options="$GVAR.RoomEquipment"
    />
    <left-text-checkbox 
      class="mb-3"
      leftText="房间特色"                   
      v-model="RoomObj.feature"
      :options="$GVAR.Roomeature"
    />
    <div class="mb-2 d-start-start">
      <left-text leftText="房型相册" />
      <upload-image @fileChange="(imgs)=>RoomObj.pic = imgs"
                    :existImgs="RoomObj.pic" :maxLength="10" editMode/>
    </div>
    <el-button @click="submitForm" class="mt-4 w-25 btn-login">提交</el-button>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState} from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  export default {
    name: 'AddEditRoom',
    props: {
      editObj: {},
      roomEdit: false,
    },
    computed: {
      ...mapState(['RoomMeetDetail','userLoginMessage']),
      ...mapGetters(['storeInfo','brand']),
      //判断是否是销售用户注册门店添加
      step() { return this.$route.query.step},
      roomPrice() {
        return [
          {text: '门市价',noweek: 'rack_rate_0',week: 'rack_rate_1'},
          {text: '采购商价',noweek: 'travel_price_0',week: 'travel_price_1'},
          {text: '订单雨价',noweek: 'fc_price_0',week: 'fc_price_1'}
        ]
      }
    },
   async created() {
    //获取房型详情信息
      if(!this.editObj.id) return;
      await this.initial();
    },
    data () {
      return {
        roomStyle: [
          { name: '单床房', id:1},
          { name: '双床房', id:2},
          { name: '三床房', id:3},
          { name: '多床房', id:4},
        ],
        RoomObj: {
          type: 1,
          feature: '',
          pic: [],
          area: '',
          window:0,
        }
      }
    },
    methods: {
      ...mapActions(['saveRoom','getRoomDetail']),
      /*编辑初始化信息*/
      async initial(){
        let data = {
          type:3,
          id:this.editObj.id
        }
        await this.getRoomDetail(data);
        this.RoomObj = {...this.RoomMeetDetail};
      },
      /*表单验证*/
      validateForm () {
        if (!this.RoomObj.title) return {code: false,msg: '请填写房间名称'}
        if (!this.$GFUN.isPositiveInteger(this.RoomObj.num)) return {code: false,msg: '房间总数填写不正确'}
        if (this.RoomObj.area <= 0) return {code: false,msg: '房间面积填写不正确'}
        if (!this.RoomObj.specs ) return {code: false,msg: '请填写床型规格'}
        if (this.RoomObj.window<=0) return {code: false,msg: '请选择房间窗户'}
        // if (this.RoomObj.pic.length <= 0) return {code: false,msg: '请至少上传一张房间图片'}
        return {code: true,msg: '表单验证通过'}
      },
      /*提交表单*/
      submitForm () {
        let result = this.validateForm();
        if (result.code) {
          this._confirm('确认提交么？',async () => {
            //处理房间相册
            let Room=JSON.parse(JSON.stringify(this.RoomObj));
            //上传图片
            Room.pic = await UploadImages(Room.pic);
            if (this.brand) Room.pic = Room.pic.join(',');
            //处理房间特征从新排序
            Room.feature=this.$verify.sortNumbersAsc(Room.feature);
            let type = 'add';
            //修改房型编辑
            if (this.editObj.title) {
              type = 'edit';
              switch (this.storeInfo.type) {
                case 8:
                case 3: Room.room_id = Room.id; delete Room.id; break;
                case 5: Room.homestay_room_id = Room.id; break;
              }
            }
            //克隆房型添加
            if(this.roomEdit){
              delete Room.id; 
              type = 'add';
            }
            //销售创建门店房型添加
            if(this.step){
              Room.store_id = this.userLoginMessage.submit_store_id;
            }
            this.saveRoom({
              type,
              data: Room,
              successFun: () => this.$emit('successFun')
            })
          })
        } else this._alert(result.msg,null,'error');
      }
    }
  }
</script>
<style scoped>
.blank_space ::v-deep .input-self-border{
  display: flex;
}
.require-middle ::v-deep .text-danger.mr-small{
  position: relative;
  top: 6px;
}
.lisq .append{ line-height: 24px;}

</style>
<style>
 .edieditRoom .form-left-text{
  width: 70px !important;
}
</style>